<template>
    <div class="video-box">
        <div class="container">
            <h2>{{tr.multimedia}}</h2>
            <div class="row no-gutterss" v-if="videos.length">
                <div class="col-sm-6 col-md-4" v-for="(v,idx) in videos" :key="idx">
                    <div class="number" style='font-size:16px;text-align:right'>{{v.date | date('D')}}</div>
                    <i-video :value="v" />
                    {{v.title}}
                    <br />
                    <br />
                </div>
            </div>
            <div class="text-center"><a href="#/multimedia" class='watch-all'>{{tr.watch_all}}</a></div>
        </div>
    </div>
</template>
<script>
import iVideo from "../components/i-video.vue"
export default {
    name: 'video-box',
    components:{iVideo},
    data() {
        return {

        }
    },
    computed: {
        videos() {
            let { lang } = this;
            return this.$store.state.videos.list.filter((v) => {
                if (!v.lang || v.lang == lang) return true;
                else return false;
            }).slice(0, 6)
        }
    }
}
</script>
<style lang="css" scoped>
h2 {
    text-transform: uppercase;
}

.video-box {
    padding: 40px 0;
    background: whitesmoke;
}

iframe {
    margin: 0;

}

.watch-all {
    text-decoration: none;
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    color: black;
}

.watch-all:hover {
    color: #1b4877;
}
</style>